import axios from "utils/axios";

export const getAllUser = async (reqData: Object) => {
    return await axios.get("/user/getall", { params: reqData });
};

export const getUser = (reqData: string) => {
    return axios.get(`/user/get/${reqData}`);
}

export const getMfaStatus = async (reqData: object) => {
    return await axios.post('/user/check-mfa', reqData);
}

export const verifyMfa = async (reqData: object) => {
    return await axios.post('/user/verify-mfa', reqData);
}

export const createUser = (reqData: Object) => {
    return axios.post('/user', reqData);
};

export const updateUser = (reqData: Object) => {
    return axios.put('/user', reqData);
};

export const deleteUser = (reqData: string) => {
    return axios.delete(`/user/${reqData}`);
};

export const activeInactiveUser = (reqData: string) => {
    return axios.patch(`/user/activeInactive/${reqData}`, {});
};
